export enum FetchStrategies {
  inPage,
  inChat,
}
